module.exports = __webpack_public_path__ + "img/link.85066303.svg";